<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="personal" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="personal">
            <personal pageType="certification"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign6.png"> 实名认证</span></h2>
              <div class="id_card" style="padding-top: 30px;display: flex;justify-content: center;;width: 44%;    padding-left: 13%;" v-if="!is_certification">
              <div style="width: 200px;margin-right: 5px;" >
                <el-upload
                  class="avatar-uploader"
                  list-type="picture"
                  action=""
                  :show-file-list="false"
                  :http-request="afterReadOne"
                >
                  <img v-if="idcard_pic_front_img" :src="idcard_pic_front_img" class="avatar" style="width:180px;height: 127px;">
                  <img  v-else src="../../../static/images/id_front.png" style="width: 180px;height: 127px;">
                </el-upload>
              </div>
              <div style="width: 200px;">
                <el-upload
                  class="avatar-uploader"
                  list-type="picture"
                  action=""
                  :show-file-list="false"
                  :http-request="afterReadTwo"
                >
                  <img v-if="idcard_pic_back_img" :src="idcard_pic_back_img" class="avatar" style="width:180px;height: 127px;">
                  <img v-else src="../../../static/images/id_back.png" style="width: 180px;height: 127px;">
                </el-upload>
              </div>
              </div>
              <div class="id_card" style="padding-top: 30px;display: flex;justify-content: center;width: 44%;    padding-left: 13%;position:relative;" v-if="is_certification">
                <div style="position:absolute;z-index: 11;top:40%;left:50%;" v-if="is_certification && (!mustPerson || (mustPerson && is_certification_person==1))">
                  <img src="../../../static/images/index_user/yrz.png" style="width: 120px;height: 60px;">
                </div>
                <div style="width: 200px;margin-right: 5px;" >
                  <el-image
                    style="width:180px;height: 127px;"
                    :src="idcard_pic_front_img"
                    fit="fit"></el-image>
                  <!--<img v-if="idcard_pic_front_img" :src="idcard_pic_front_img"   style="width:180px;height: 127px;">-->
                </div>
                <div style="width: 200px;margin-right: 5px;" >
                  <el-image
                    style="width:180px;height: 127px;"
                    :src="idcard_pic_back_img"
                    fit="fit"></el-image>
                  <!--<img v-if="idcard_pic_back_img" :src="idcard_pic_back_img"  style="width:180px;height: 127px;">-->
                </div>
              </div>
              <dl class="safe" style="padding-top: 20px;padding-left: 13%;    padding-bottom: 0px;">
                <dd v-if="isShow"><span class="title"><img src="../../../static/images/required.png"> 姓名：</span><em><el-input v-model="user_name" placeholder="请输入姓名" :readonly="is_certification"  style="width: 93%;margin-right: 5px;"></el-input></em> </dd>
                <dd v-if="isShow"><span class="title"><img src="../../../static/images/required.png"> 身份证号：</span><em><el-input v-model="user_idcard" placeholder="请输入身份证号" :readonly="is_certification" maxlength="18"  style="width: 93%;margin-right: 5px;"></el-input></em> </dd>
                <dd v-if="isShow"><span class="title"><img src="../../../static/images/required.png"> 户籍地址：</span><em><el-input type="textarea" v-model="user_idcard_address" placeholder="请输入户籍地址" :readonly="is_certification" autosize maxlength="50" style="width: 93%;margin-right: 5px;"></el-input></em> </dd>

              </dl>
              <div v-if="qxAlertFlag" style="width:44%;padding-left: 13%;">
                <el-alert
                  :closable="false"
                  :title="alertMsg"
                  :type="alertType"
                  show-icon>
                </el-alert>
              </div>
              <dl class="safe" style="padding-top: 5px;padding-left: 13%;">
                <dd class="safe_button" v-if="isShow && !is_certification" ><button @click="userReg">提交</button></dd>
                <dd class="safe_button" v-if="isShow && is_certification" ><button @click="apkShowFlag=true" style="width: 300px;">    下载APP，完成实人认证    </button>
                  <span style="font-size: 12px;color: red;width: 300px;margin-left: 20%;">* 下载APP，进行公安人脸认证，可进行更多业务办理。</span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="apkShowFlag" :lockScroll="false"
        width="500px" >
        <div style="width: 100%;text-align: center">
          <img src="../../../static/images/PublicApkDownLoadPic.png" style="width:300px;height: 300px;"/>
          <div style="width: 100%;line-height: 30px;">*请使用安卓手机扫码下载</div>
        </div>
      </el-dialog>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
import personal from "../../components/Personal";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers,personal
  },
  data() {
    let _self=this;
    return {
      apkShowFlag:false,
      active: 'guideIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      idcard_pic_front:"",
      idcard_pic_back:"",
      idcard_pic_front_img:'',
      idcard_pic_back_img:'',
      user_idcard_address:"",
      user_nations_id:"",
      user_nations:"",
      user_name:'',
      user_idcard:'',
      is_certification:false,
      is_certification_person:0,//实人
      mustPerson:false, //是否必须实人认证
      alertType:'error',
      alertMsg:'',
      isShow:false,
      qxAlertFlag:false,
      loginShow:false,
      gotoIndex:false,
      idcard_head_pic:'',
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  created(){
    this.initData();
    var userInfo=this.$cookies.get('userInfo')
    if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
      this.loginShow=true;
      this.gotoIndex=true;
    }
  },
  mounted(){
  },
  methods: {
    initData(){
      var t=this;
      this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.isCertification=='1'){
            t.user_name=response.data.data.userName;
            t.user_idcard=response.data.data.userIdcard;
            t.idcard_pic_front=response.data.data.idcardPicFront;
            t.idcard_pic_back=response.data.data.idcardPicBack;
            t.user_idcard_address=response.data.data.userIdcardAddress;
            t.user_nations_id=response.data.data.userNationsId;
            t.user_nations=response.data.data.userNations;
            t.is_certification=true;
            t.mustPerson=response.data.data.mustPerson;
            t.is_certification_person=response.data.data.isCertificationPerson;
            t.idcard_pic_back_img=this.getImg(this.idcard_pic_back);
            t.idcard_pic_front_img=this.getImg(this.idcard_pic_front);
            t.isShow=true;
          } else {
            t.alertMsg='请先上传身份证人像面、国徽面！';
            t.alertType="error";
          }
        } else {
          t.alertMsg='请先上传身份证人像面、国徽面！';
          t.alertType="error";
        }
      })
    },
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
    afterReadOne(files){
      if(files){
        this.isShow=false;
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='idcard_pic_front';
        files.attrName="ic_"+this.$util.uuid.uuid2();
        this.alertMsg='身份证人像面上传中...';
        this.alertType="warning";
        this.qxAlertFlag=true;
        this.idcard_pic_front_img='';
        this.idcard_pic_front='';
        this.compressImg(files);
        // this.afterReadFile(files);
      }
    },
    afterReadTwo(files){
      if(files) {
        this.isShow=false;
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='idcard_pic_back';
        files.attrName="ic_"+this.$util.uuid.uuid2();
        this.alertMsg='身份证国徽面上传中...';
        this.alertType="warning";
        this.qxAlertFlag=true;
        this.idcard_pic_back_img='';
        this.idcard_pic_back='';
        this.compressImg(files);

        // this.afterReadFile(files);
      }
    },
    compressImg(file) {
      var t=this;
      if(/\/(?:jpeg|png)/i.test(file.file.type)&&file.file.size>2097152) {
        this.photoCompress(file,{
          quality: 0.5
        },function (base64Codes) {
          var bl = t.convertBase64UrlToBlob(base64Codes);
          let bytes=atob(base64Codes.split(',')[1]);        //去掉url的头，并转换为byte
          //处理异常,将ascii码小于0的转换为大于0
          let ab = new ArrayBuffer(bytes.length);
          let ia = new Uint8Array(ab);
          for (let i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
          }
          let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
          if(fileItem){
            file.file=fileItem;
            t.afterReadFile(file);
          }
        })
      }else{
        this.afterReadFile(file);
      }
    },
    /**
     * @param file: 上传的图片
     * @param objCompressed：压缩后的图片规格
     * @param objDiv：容器或回调函数
     */
    photoCompress(file, objCompressed, objDiv){
      var ready=new FileReader();
      ready.readAsDataURL(file.file);
      var tt=this;
      ready.onload=function(){
        var fileResult=this.result;
        tt.canvasDataURL(fileResult,objCompressed,objDiv)
      }
    },

    canvasDataURL(path, objCompressed, callback) {
      var img = new Image();
      img.src = path;
      img.onload = function () {
        var that = this;
        //默认压缩后图片规格
        var quality = 0.5;
        var w = that.width;
        var h = that.height;
        var scale = w / h;
        //实际要求
        w = objCompressed.width || w;
        h = objCompressed.height || (w / scale);
        if(objCompressed.quality && objCompressed.quality > 0 && objCompressed.quality <= 1){
          quality = objCompressed.quality;
        }
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);

        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        callback(base64);
      }
    },

    convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    },
    afterReadFile(file){
      file.status='uploading';

      let formData = new FormData;
      formData.append('_sk','app');
      formData.append('upload',file.file);
      formData.append('type',file.type);
      formData.append('attachName',"ic_"+this.$util.uuid.uuid2());
      var ttt=this;
      this.$https.postFile('attach/upload.do',formData,(response)=>{
        if (response.status===200&&response.data.isOk){
          // file.attachId=response.data.bean.attach_id;
          if(file.type=='idcard_pic_front'){
            ttt.idcard_pic_front=response.data.bean.attach_id;
            ttt.idcard_pic_front_img=ttt.getImg(ttt.idcard_pic_front);
            ttt.qxAlertFlag=true;
            ttt.alertMsg='身份证人像面上传完成...';
            ttt.alertType="warning";
          }else{
            ttt.idcard_pic_back=response.data.bean.attach_id;
            ttt.idcard_pic_back_img=ttt.getImg(ttt.idcard_pic_back);
            ttt.qxAlertFlag=true;
            ttt.alertMsg='身份证国徽面上传完成...';
            ttt.alertType="warning";
          }
          file.status='done'
          ttt.uploadOver();
        }else {
          file.status='failed';
          ttt.alertMsg='图片上传失败，请重新选择文件上传...';
          ttt.alertType="error";
        }
      });
      //重新验证表单项
      // this.$refs['photo'].resetValidation();
    },
  uploadOver(){
    if(this.idcard_pic_front!='' && this.idcard_pic_back !=''){
      // this.$toast.loading({
      //   duration:0,
      //   message: '身份证信息识别中...',
      //   forbidClick: true,
      // });
      this.qxAlertFlag=true;
      this.alertMsg='身份证信息识别中，请稍后......';
      this.alertType="warning";
      //上传正面照
      var ttt=this;
      this.$https.post('api/pu/getIdCardFromPic.do',{attr_id:this.idcard_pic_front},(response)=>{
        if (response.status===200&&response.data.code==200){
          if(response.data.data.ocr_success){
            //判断身份照背面是否合法
            ttt.$https.post('api/pu/getIdCardFromPic.do',{attr_id:this.idcard_pic_back},(response_back)=>{
              if(response_back.data.data.ocr_success){
                ttt.user_name=response.data.data.person_name;
                ttt.user_idcard=response.data.data.person_uid;
                ttt.user_idcard_address=response.data.data.reg_address;
                ttt.user_nations_id=response.data.data.nations_type_id;
                ttt.user_nations=response.data.data.nation_str;

                if(response.data.data.headImg && response.data.data.headImg !=''){
                  let bytes=atob(response.data.data.headImg);        //去掉url的头，并转换为byte
                  //处理异常,将ascii码小于0的转换为大于0
                  let ab = new ArrayBuffer(bytes.length);
                  let ia = new Uint8Array(ab);
                  for (let i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                  }
                  let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
                  let formData = new FormData;
                  formData.append('_sk','app');
                  formData.append('upload',fileItem);
                  formData.append('type',"FJ_1_HEADPHOTO_PIC");
                  formData.append('attachName',"head_"+this.$util.uuid.uuid2());
                  ttt.$https.postFile('attach/upload.do',formData,(responseaa)=> {
                    if (responseaa.status === 200 && responseaa.data.isOk) {
                        ttt.idcard_head_pic=responseaa.data.bean.attach_id;
                    }
                  });
                }
                ttt.alertMsg='';
                ttt.alertType="success";
                ttt.isShow=true;
                this.qxAlertFlag=false;
              }else{
                ttt.isShow=false;
                  ttt.idcard_pic_back='';
                  ttt.idcard_pic_back_img='';
                ttt.alertMsg='身份证国徽面识别失败，请重新上传！';
                ttt.alertType="error";
              }
            });
          }else{
            ttt.isShow=false;
            //身份证信息读取失败，要求重新上传
            ttt.alertMsg='身份证信息识别失败，请重新上传！';
            ttt.alertType="error";
              ttt.idcard_pic_front='';
              ttt.idcard_pic_front_img='';
              ttt.idcard_pic_back='';
              ttt.idcard_pic_back_img='';
              ttt.idcard_head_pic='';
          }
        }
      });
    }
  },
    checkUid(uid) {
      var aCity={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"}
      var iSum=0 ;
      var info=""
      var sId = uid;
      if (sId.length==15){
        sId =  this.contertToNewCardNumber(sId);
      }
      //进行身份证的校验
      if(!/^\d{17}(\d|x)$/i.test(sId)) {
        // $$msg.error("你输入的身份证长度或格式错误");
        return false;
      };
      sId=sId.replace(/x$/i,"a");
      if(aCity[parseInt(sId.substr(0,2))]==null){
        // $$msg.error("您的身份证地区非法");
        return false;
      };
      var   sBirthday=sId.substr(6,4)+"-"+Number(sId.substr(10,2))+"-"+Number(sId.substr(12,2));
      var d=new Date(sBirthday.replace(/-/g,"/")) ;
      if(sBirthday!=(d.getFullYear()+"-"+ (d.getMonth()+1) + "-" + d.getDate())){
        this.alertMsg='请输入正确的身份证号！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      };
      for(var i = 17;i>=0;i --) iSum += (Math.pow(2,i) % 11) * parseInt(sId.charAt(17 - i),11) ;
      if(iSum%11!=1){
        this.alertMsg='请输入正确的身份证号！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      };
      this.alertMsg='';
      this.alertType="";
      this.qxAlertFlag=false;
      return true;
    },
    contertToNewCardNumber(oldUID) {
      oldUID += '';
      if (oldUID.length != 15) return oldUID.toUpperCase();

      var buf = [];
      buf.push(oldUID.substring(0, 6));
      buf.push("19");
      buf.push(oldUID.substring(6));
      buf.push($$uid.calculateVerifyCode(buf.join('')));
      return buf.join('').toUpperCase();
    },
    userReg() {
      if(this.idcard_pic_front==''){
        this.alertMsg='请上传身份证人像面照！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      }
      if(this.idcard_pic_back==''){
        this.alertMsg='请上传身份证国徽面照！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      }
      if(this.user_name==''){
        this.alertMsg='请输入姓名！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      }
      if(this.user_idcard==''){
        this.alertMsg='请输入身份证号！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      }else{
        if(!this.$util.uid.validatorUid(this.user_idcard)){
          return false;
        }
      }
      // user_name:'',
      // user_idcard:'',
      // isDisabled:false,
      // is_certification:false,
      // infoType:"",
      // errorMsg:"",
      // user_idcard_one_file:[],
      // user_idcard_two_file:[],
      // idcard_pic_front:"",
      // idcard_pic_back:"",
      // user_idcard_address:"",
      // user_nations_id:"",
      // user_nations:""
      if(this.user_idcard_address==''){
        this.alertMsg='请输入户籍地址！';
        this.alertType="error";
        this.qxAlertFlag=true;
        return false;
      }
      this.alertMsg='！';
      this.alertType="";
      this.qxAlertFlag=false;
      this.isDisabled=true;

      var param={
        user_name:this.user_name,
        user_idcard:this.user_idcard,
        idcard_pic_front:this.idcard_pic_front,
        idcard_pic_back:this.idcard_pic_back,
        user_idcard_address:this.user_idcard_address,
        user_nations_id:this.user_nations_id,
        user_nations:this.user_nations,
        user_idcard_photo:this.idcard_head_pic
      }
      var ttt=this;
      //从服务器获取code请求路径snsapi_base静默，snsapi_userinfo用户授权
      this.$https.post("api/pu/peopleUserCertification.do",param,response=>{
        if (response.status === 200 && response.data.code===200) {
          //弹框成功提示，并返回登录页面
          ttt.alertMsg='实名认证成功！';
          ttt.alertType="success";
          ttt.qxAlertFlag=true;
          var userInfo=ttt.$cookies.get("userInfo")
          if(userInfo){
            userInfo.userName=ttt.user_name
            ttt.$cookies.set("userInfo",userInfo,"1D")
            }
          ttt.$message({
            message: '实名认证成功！',
            type: 'success',
            offset:250,
            duration:2500,
            onClose:function(){
              if(ttt.mustPerson){
                ttt.initData();
              }else{
              ttt.$router.back()
              }
            }
          });
        }else   if (response.data.code===201) {
          //弹框成功提示，并返回登录页面
          ttt.isDisabled=false;
          ttt.alertMsg='实名认证失败，身份证信息已绑定其他账户！';
          ttt.alertType="error";
          ttt.qxAlertFlag=true;
          return;
        } else {
          ttt.isDisabled=false;
          //短信校验码错误
          ttt.alertMsg='实名认证失败，请确定身份证和姓名匹配！';
          ttt.alertType="error";
          ttt.qxAlertFlag=true;
          return;
        }
      })
    },
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
  }
}



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/personal/PeopleCertification.vue